import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoImage from "../assets/images/nnfitwatermark.png";

export const generateWorkoutPDF = (member, workoutPlan, gym) => {
  if (!gym) {
    alert("Gym details not found.");
    return;
  }

  if (!member) {
    alert("Member details not found.");
    return;
  }

  if (!workoutPlan) {
    alert("Workout plan not found.");
    return;
  }

  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // =====================================================
    // HEADER
    // =====================================================

    doc.setFillColor(79, 70, 229);
    doc.rect(0, 0, pageWidth, 34, "F");

    // -----------------------------------------------------
    // GYM LOGO
    // IMPORTANT: Use logoBase64 to avoid Firebase CORS
    // -----------------------------------------------------

    if (gym?.logoBase64) {
      try {
        let gymLogoType = "PNG";

        if (
          gym.logoBase64.startsWith("data:image/jpeg") ||
          gym.logoBase64.startsWith("data:image/jpg")
        ) {
          gymLogoType = "JPEG";
        }

        doc.addImage(gym.logoBase64, gymLogoType, 15, 6, 22, 22);
      } catch (error) {
        console.error("Gym Logo Error:", error);
      }
    }

    // =====================================================
    // NN FIT LOGO
    // =====================================================

    try {
      doc.addImage(logoImage, "PNG", pageWidth - 38, 7, 22, 22);
    } catch (error) {
      console.error("NN FIT Logo Error:", error);
    }

    // =====================================================
    // GYM NAME
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);

    doc.text(gym?.gymName || "GYM SAAS", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    doc.text("Workout Management", pageWidth / 2, 23, {
      align: "center",
    });

    // =====================================================
    // TITLE
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(30, 30, 30);

    doc.text("WORKOUT PLAN", pageWidth / 2, 50, {
      align: "center",
    });

    doc.setDrawColor(255, 120, 0);
    doc.setLineWidth(0.8);

    doc.line(15, 56, pageWidth - 15, 56);

    // =====================================================
    // GYM INFORMATION
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(79, 70, 229);

    doc.text("Gym Information", 15, 68);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);

    doc.text(`Gym Name : ${gym?.gymName || "-"}`, 15, 76);

    doc.text(`Owner : ${gym?.ownerName || "-"}`, 15, 83);

    doc.text(`Phone : ${gym?.phone || "-"}`, 15, 90);

    doc.text(`Address : ${gym?.address || "-"}`, 15, 97);

    // =====================================================
    // MEMBER INFORMATION
    // =====================================================

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(79, 70, 229);

    doc.text("Member Information", 15, 110);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(50, 50, 50);

    // IMPORTANT:
    // Custom Member ID
    // NOT Firestore document ID

    doc.text(`Member ID : ${member?.memberId || "-"}`, 15, 118);

    doc.text(`Member Name : ${member?.fullName || "-"}`, 15, 125);

    doc.text(`Phone : ${member?.phone || "-"}`, 15, 132);

    doc.text(`Trainer : ${member?.trainerName || "-"}`, 15, 139);

    doc.text(`Workout Plan : ${workoutPlan?.planName || "-"}`, 15, 146);

    // =====================================================
    // WATERMARK
    // =====================================================

    try {
      doc.setGState(
        new doc.GState({
          opacity: 0.06,
        }),
      );

      doc.addImage(logoImage, "PNG", 55, 150, 100, 100);

      doc.setGState(
        new doc.GState({
          opacity: 1,
        }),
      );
    } catch (error) {
      console.error("Watermark Error:", error);
    }

    // =====================================================
    // WORKOUT TABLE
    // =====================================================

    autoTable(doc, {
      startY: 155,

      head: [["Day", "Workout"]],

      body: [
        ["Monday", workoutPlan?.monday || "-"],
        ["Tuesday", workoutPlan?.tuesday || "-"],
        ["Wednesday", workoutPlan?.wednesday || "-"],
        ["Thursday", workoutPlan?.thursday || "-"],
        ["Friday", workoutPlan?.friday || "-"],
        ["Saturday", workoutPlan?.saturday || "-"],
        ["Sunday", workoutPlan?.sunday || "-"],
      ],

      theme: "grid",

      margin: {
        left: 15,
        right: 15,
      },

      headStyles: {
        fillColor: [79, 70, 229],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },

      bodyStyles: {
        textColor: [40, 40, 40],
        valign: "middle",
      },

      columnStyles: {
        0: {
          cellWidth: 40,
          halign: "center",
          fontStyle: "bold",
        },

        1: {
          cellWidth: "auto",
          halign: "left",
        },
      },

      styles: {
        fontSize: 10,
        cellPadding: 5,
        lineColor: [220, 220, 220],
        lineWidth: 0.3,
      },

      alternateRowStyles: {
        fillColor: [248, 248, 248],
      },
    });

    // =====================================================
    // FOOTER
    // =====================================================

    const totalPages = doc.internal.getNumberOfPages();

    for (let page = 1; page <= totalPages; page++) {
      doc.setPage(page);

      doc.setDrawColor(220, 220, 220);

      doc.line(15, pageHeight - 18, pageWidth - 15, pageHeight - 18);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(120, 120, 120);

      doc.text("Powered By NN FIT", 15, pageHeight - 10);

      doc.text(
        `Generated : ${new Date().toLocaleString()}`,
        pageWidth / 2,
        pageHeight - 10,
        {
          align: "center",
        },
      );

      doc.text(
        `Page ${page} of ${totalPages}`,
        pageWidth - 15,
        pageHeight - 10,
        {
          align: "right",
        },
      );
    }

    // =====================================================
    // SAVE
    // =====================================================

    const fileName = member?.memberId || member?.fullName || "Member";

    doc.save(`${fileName}-WorkoutPlan.pdf`);
  } catch (error) {
    console.error("Workout PDF Error:", error);

    alert("Failed to generate workout PDF.");
  }
};
